var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-page',{attrs:{"no-padding":""}},[_c('div',{staticClass:"h-100"},[_c('participants',{attrs:{"message-thread-id":_vm.$route.params.id}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }